export default __webpack_public_path__ + "static/media/daily_dose_reminder_inactive.a1d07edb.svg";